import React from "react";
import assetify from "@quintype/framework/assetify";
import { string } from "prop-types";

import DefaultDesktopLogo from "../../../../assets/images/palo-bangla.svg";
import KishorAloLogo from "../../../../assets/images/kishoralo.svg";
import ProtichintaLogo from "../../../../assets/images/protichinta-icon.png";
import BigganchintaLogo from "../../../../assets/images/biggan-chinta.svg";
import TrustLogo from "../../../../assets/images/trust-logo.svg";
import NagorikLogo from "../../../../assets/images/nagorik.svg";
import NaLogo from "../../../../assets/images/Na_logo.svg";
import BondhushavaLogo from "../../../../assets/images/bondhushava.svg";
import EnLogo from "../../../../assets/images/palo-english.svg";

import "./desktopLogo.m.css";

const DesktopLogo = ({ location, lang, datatrackingcategory = "", datatrackingaction = "" }) => {
  const renderLogo = () => {
    if (location === "bn" && lang === "bn") {
      return (
        <img
          src={`${assetify(DefaultDesktopLogo)}`}
          alt="palo-logo"
          styleName="palo-logo"
          data-tracking-category="Prothom Alo Logo"
          data-tracking-action="Click"
          data-tracking-label="প্রথম আলো লোগো"
        />
      );
    } else if (lang === "en") {
      return (
        <img
          src={`${assetify(EnLogo)}`}
          alt="Prothom Alo English"
          styleName="palo-logo"
          data-tracking-category={datatrackingcategory}
          data-tracking-action={datatrackingaction}
          data-tracking-label="প্রথম আলো লোগো ইংলিশ"
        />
      );
    } else if (location === "kishoralo") {
      return (
        <img
          src={`${assetify(KishorAloLogo)}`}
          alt="কিশোর আলো"
          styleName="palo-logo"
          data-tracking-category={datatrackingcategory}
          data-tracking-action={datatrackingaction}
          data-tracking-label="কিশোর আলো লোগো"
        />
      );
    } else if (location === "protichinta") {
      return (
        <img
          src={`${assetify(ProtichintaLogo)}`}
          alt="প্রতিচিন্তা"
          styleName="palo-logo"
          data-tracking-category={datatrackingcategory}
          data-tracking-action={datatrackingaction}
          data-tracking-label="প্রতিচিন্তা লোগো"
        />
      );
    } else if (location === "bigganchinta") {
      return (
        <img
          src={`${assetify(BigganchintaLogo)}`}
          alt="বিজ্ঞানচিন্তা"
          styleName="palo-logo"
          data-tracking-category={datatrackingcategory}
          data-tracking-action={datatrackingaction}
          data-tracking-label="বিজ্ঞানচিন্তা লোগো"
        />
      );
    } else if (location === "nagorik-sangbad") {
      return (
        <img
          src={`${assetify(NagorikLogo)}`}
          alt="নাগরিক সংবাদ"
          styleName="palo-logo"
          data-tracking-category={datatrackingcategory}
          data-tracking-action={datatrackingaction}
          data-tracking-label="নাগরিক সংবাদ লোগো"
        />
      );
    } else if (location === "trust") {
      return (
        <img
          src={`${assetify(TrustLogo)}`}
          alt="প্রথম আলো ট্রাস্ট"
          styleName="palo-logo"
          data-tracking-category={datatrackingcategory}
          data-tracking-action={datatrackingaction}
          data-tracking-label="প্রথম আলো ট্রাস্ট লোগো"
        />
      );
    } else if (location === "northamerica") {
      return (
        <img
          src={`${assetify(NaLogo)}`}
          alt="উত্তর আমেরিকা"
          styleName="palo-logo"
          data-tracking-category={datatrackingcategory}
          data-tracking-action={datatrackingaction}
          data-tracking-label="উত্তর আমেরিকা লোগো"
        />
      );
    } else if (location === "bondhushava") {
      return (
        <img
          src={`${assetify(BondhushavaLogo)}`}
          alt="প্রথম আলো বন্ধুসভা"
          styleName="palo-logo"
          data-tracking-category={datatrackingcategory}
          data-tracking-action={datatrackingaction}
          data-tracking-label="প্রথম আলো বন্ধুসভা লোগো"
        />
      );
    }
  };
  return <h2 className="desktop-logo">{renderLogo()}</h2>;
};

DesktopLogo.propTypes = {
  location: string,
  lang: string,
  datatrackingcategory: string,
  datatrackingaction: string,
};

export default DesktopLogo;
